import { ACTION_BUTTON_MESSAGES, ActionButtonMessages } from "../action-buttons.messages";
import { SIDEBAR_MESSAGES, SidebarMessages } from "../layout/sidebar";

export type CompanyPaymentsMessages = ActionButtonMessages &
  SidebarMessages & {
    pageTitle: string;
    breadCrumbTitle: string;
    productColumn: string;
    planColumn: string;
    statusColumn: string;
    dueDateColumn: string;
    valueColumn: string;
    paymentColumn: string;
    rowsPerPage: string;
    paymentNotFoundError: string;
    paymentNotFoundDescription: string;
    paymentNotFoundAlt: string;
    paymentErrorToLoad: string;
    payInvoiceButton: string;
    newStatusMessage: string;
    billingSentStatusMessage: string;
    paidStatusMessage: string;
    cancelledStatusMessage: string;
    delayedStatusMessage: string;
  };

export const COMPANY_PAYMENTS_MESSAGES: CompanyPaymentsMessages = {
  pageTitle: "Pagamentos",
  breadCrumbTitle: "Pagamentos",
  productColumn: "Produto",
  planColumn: "Plano",
  statusColumn: "Status",
  dueDateColumn: "Vencimento",
  valueColumn: "Valor",
  paymentColumn: "Pagamento",
  rowsPerPage: "Linhas por página",
  paymentNotFoundError: "Nenhum pagamento encontrado",
  paymentNotFoundDescription: "Não há pagamentos registrados para esta empresa.",
  paymentNotFoundAlt: "Pagamentos não encontrados",
  paymentErrorToLoad: "Erro ao carregar pagamentos",
  payInvoiceButton: "Pagar fatura",
  newStatusMessage: "Novo",
  billingSentStatusMessage: "Cobrança enviada",
  paidStatusMessage: "Pago",
  cancelledStatusMessage: "Cancelado",
  delayedStatusMessage: "Em atraso",
  ...ACTION_BUTTON_MESSAGES,
  ...SIDEBAR_MESSAGES,
};

export default COMPANY_PAYMENTS_MESSAGES;
